import React from 'react';
import { FiMapPin, FiLock } from 'react-icons/fi';

/**
 * Switch "Ubicación": al activarlo envía disable_location_restriction,
 * al desactivarlo envía enable_location_restriction.
 */
const UbicacionToggle = ({
  isUbicacionEnabled,
  onToggle,
  disabled = false,
  deviceId,
  className = ''
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onToggle(deviceId, isUbicacionEnabled ? 'enable_location_restriction' : 'disable_location_restriction');
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={disabled}
      className={`
        relative inline-flex h-7 w-14 items-center rounded-full transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 shadow-sm
        ${isUbicacionEnabled
          ? 'bg-teal-600 hover:bg-teal-700 shadow-teal-200'
          : 'bg-gray-200 hover:bg-gray-300 shadow-gray-200'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
      title={isUbicacionEnabled ? 'Deshabilitar ubicación' : 'Habilitar ubicación'}
    >
      <span
        className={`
          inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-all duration-300 ease-in-out
          ${isUbicacionEnabled ? 'translate-x-8' : 'translate-x-1'}
        `}
      />

      <div className={`
        absolute left-1.5 flex items-center justify-center transition-all duration-300 ease-in-out
        ${isUbicacionEnabled ? 'opacity-0 scale-0' : 'opacity-100 scale-100'}
      `}>
        <FiLock size={10} className="text-gray-500" />
      </div>

      <div className={`
        absolute right-1.5 flex items-center justify-center transition-all duration-300 ease-in-out
        ${isUbicacionEnabled ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
      `}>
        <FiMapPin size={10} className="text-white" />
      </div>
    </button>
  );
};

export default UbicacionToggle;
